<template>
  <v-dialog :value="dialogProp.show" persistent :max-width="maxWidth">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" :color="color">
        <v-toolbar-title>
          {{ $t('Подтверждение операции') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="py-3">
        <v-row v-if="dialogProp.text">
          <v-col class="v-label v-label--active textcolor--text font-weight-bold">
            {{ dialogProp.text }}
          </v-col>
        </v-row>
        <slot
            name="additional"
            :model="dialogProp.additional" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            :color="color"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            text: null,
            warning: false,
            additional: null,
            show: false,
            callback: null
          }
        }
      },
      maxWidth: {
        type: [String, Number],
        default: '600'
      }
    },
    data () {
      return { }
    },
    computed: {
      color () {
        return this.dialogProp.warning
          ? 'warning'
          : 'primary'
      }
    },
    methods: {
      continueOperation: function () {
        if (this.dialogProp.callback) {
          this.dialogProp.callback(this.dialogProp.additional)
        }
        this.cancel()
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
